import React, { useState,useEffect }  from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory} from 'react-router-dom';
import { clearAll } from 'src/redux/registrant';
import vw from 'src/styles/utils';
import {setDR, setDRPlugin} from 'src/scripts/requests';
import media from 'src/styles/media';
import Helmet from 'react-helmet';

const DR = (props) => {
  const { person, email,profile } = useSelector((state) => state.registrant);
  const [isLoading, setIsLoading] = useState(false);
  const [isStepOne, setStepOne] = useState(true);
  const [isStepTwo, setStepTwo] = useState(false);
  const [isStepThree, setStepThree] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();




  let submitting = false;


  
  function getQueryVariable (variable)  {
    const query = window.location.search.substring(1);
    const vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
      let pair = vars[i].split('=');
      if (decodeURIComponent(pair[0]) === variable) {

        //return decodeURIComponent(pair[1]);
        
        return decodeURIComponent(pair[1]);
      }else{
        //return 0;
     
        return 0
      }

    }
    console.log('Query variable %s not found', variable);
  }
  // if(profile == null && getQueryVariable("id") == ""){
  //   window.location.replace("/email");

  // }
  let contactID = "";
  if(profile != null){
    contactID = profile[0].id;
  }else{
    contactID = getQueryVariable("id");
  }
  
  //const contactID = getQueryVariable("id") != "" ? getQueryVariable("id") : profile[0].id;
 

  const redirectType = getQueryVariable("type")
  
  useEffect(() => {
   // getQueryVariable("id")
    // if(!){
    //   if(!submitting){
    //     console.log("NO ID")
    //     //window.location.replace("/email/");
    //   }
    // }

   
  }, [])
  

  

// const redirectToEmail = () =>{
//   if(contactID === undefined || contactID === ''){
//     if(!submitting){
//       console.log("NO ID")
//       window.location.replace("/email/");
//     }
//   }
 

// }

  const handleStepOne = (e) => {
    e.preventDefault();
   if(contactID === 0){
    window.location.replace("/email/");
    return
   }
   console.log(">>>>>" + contactID)
    setStepOne(false)
    setStepTwo(true)
    
  }
  const handleStepTwo = (e) => {
    e.preventDefault();
    
    console.log(">>>>>" + contactID)
   

    if(document.getElementById('DRTS_Check').checked){
      setStepOne(false)
      setStepTwo(false)
      setStepThree(true)
    }else{
   
      document.getElementById('DRTS_Check').style.boxShadow = "0px 0px 10px #DE5647"
    }
    
  }
  
  async function handleStepThree(e) {
    e.preventDefault();
   
    if(submitting){
      return
    }


    if (document.getElementById('DRUPS_Check').checked) {
      submitting = true;
      document.getElementById('FinalBtn').innerHTML = "Processing..."
      document.getElementById('FinalBtn').style.opacity = .5
      console.log(">>>>>" + contactID)

      if(redirectType !== 'hsf'){

      }else{

      }

      const setDRStatus =  redirectType !== 'hsf' ? await setDR(contactID) : await setDRPlugin(contactID);

      
     // console.log(setDRStatus)
      if(setDRStatus.status === "success"){
        if(redirectType !== 'hsf'){
          //dispatch(clearAll());
          window.location.replace("/thankyou/");
          //history.push('/thankyou')
        }else{
          history.push('/home-selection-form');
        }
      }else{
        submitting = false;
        document.getElementById('FinalBtn').innerHTML = "Agree"
      }
    } else {

      document.getElementById('DRUPS_Check').style.boxShadow = "0px 0px 10px #DE5647";
    }

  }

  return (
    <Root>
      <Helmet meta={[
        {
          name: 'robots',
          content: 'noindex,nofollow',
        }
		]}
    />
      <Logo src={require('src/assets/images/logo.svg')} alt="logo" />
      { isStepOne ? (
        <>
      <Title>
        <h1>Disclosure Requirements</h1>
        <h3>BC FINANCIAL SERVICES AUTHORITY</h3>
        <p>
          These new disclosure forms are designed with you, the consumer, in mind - presenting information clearly and in plain language, to help you make informed choices. These forms will help explain the special legal duties that real estate professionals owe to their clients as well as the risks of being an unrepresented party in a real estate transaction, and we invite you to contact us with any questions you may have in respect of these forms. 
        </p>

        
        <nav>
     
        <a onClick={handleStepOne}>Continue</a>
      </nav>
        
        
      </Title>
        </>
      ):(
        <></>
      )}


      { isStepTwo ? (
        <>
        <DRTS>
        <h3><span>Scroll down to proceed</span></h3>
        <h1>Disclosure of Representation In Trading Services</h1>
        <br />
          <img src={require('src/assets/images/BCFS_DRTS.jpg')} />
        
        
        <ConsentBox>
        <table>
          <tbody>
              <tr>
                <td>  <input type="checkbox" id="DRTS_Check"/></td>
      
                <td>
        <label> I have received and read the Disclosure of Representation in Trading Services Form</label>

                </td>
              </tr>
              </tbody>
            </table>
      
          <nav>
          <a onClick={handleStepTwo}>agree</a>
          </nav>
          </ConsentBox>
      </DRTS>
        </>
      ):(
        <></>
      )}
      { isStepThree ? (
        <>
        <DRUPS>
        <h3><span>Scroll down to proceed</span></h3>
          <h1>Disclosure of Risks To Unrepresented Parties</h1>
          <br />
          <img src={require('src/assets/images/BCFS_DRUPS.jpg')} />
          <ConsentBox>
            <table>
              <tbody>
              <tr>
                <td><input type="checkbox" id="DRUPS_Check" /></td>
                <td>
       <label> I have received and read the Disclosure of Risks to Unrepresented Parties Form </label>

                </td>
              </tr>
              </tbody>
            </table>
        
          <nav>
          <a onClick={handleStepThree} id="FinalBtn">agree</a>
          </nav>
          </ConsentBox>
      </DRUPS>
        </>
         ):(
          <></>
      )}
      
      
     
    </Root>
  );
};

DR.propTypes = {

}

const ConsentBox = styled.div`

${vw('padding-top', 20, 75, 50)}
input[type=checkbox] { 
  width:30px; 
  height: 30px;
  
}
input[type=checkbox]:checked {
    box-shadow:none;
  }

label{
 display: block;
 ${vw('padding-left', 10)}
 font-family: Gotham Medium;
 text-transform: none;
 ${vw('font-size', 11, 18)}
  ${vw('line-height', 14, 24)}
}
`

const Root = styled.main`

${vw('padding-top', 50, 75, 150)}
  ${vw('padding-left', 25, 60, 100)}
  ${vw('padding-right', 25, 60, 300)} 
  ${vw('padding-bottom', 50, 75, 100)}

  nav {
    /* display: flex;
    justify-content: flex-end; */
    
    ${vw('width', 150, 250, 250)}
    ${vw('margin-top', 25, 30)}
    text-align: center;
  }

  a {
    display: block;
    font-family: Gotham Book;
    font-style: normal;
    font-weight: normal;
    text-transform: capitalize;
    color: #000000;
    cursor: pointer;
    ${vw('font-size', 9, 12)}
    ${vw('line-height', 9, 11)}
    ${vw('padding-top', 11, 17)}
    ${vw('padding-bottom', 11, 17)}

    &:last-of-type {
      font-family: Sharp Sans TRIAL;
      font-weight: bold;
      text-transform: uppercase;
      color: #FFFFFF;
      background: #DE5647;
      ${vw('font-size', 9, 12)}
      ${vw('line-height', 12, 16)}
      ${vw('letter-spacing', 0.72)}
      ${vw('padding-left', 17, 40)}
      ${vw('padding-right', 17, 40)}
    }

    }

    font-family: Gotham Black;
 

 
 text-transform: uppercase;
h1{
  ${vw('font-size', 20, 50)}
 ${vw('padding-bottom', 10, 75, 20)}
}
h3{
  ${vw('font-size', 14, 25)}
 ${vw('padding-bottom', 10, 75, 30)}
}
p{
  font-family: Big Caslon;
   font-style: normal;
   font-weight: normal;
   color: #000000;
   text-transform: none;
   ${vw('font-size', 14, 20)}
   ${vw('line-height', 22, 32)}
 

}
 span {
   color: #DE5647;
 }


`;
const DRUPS = styled.div`

img{ width:100%; border: solid 1px #000;}

`;
const DRTS = styled.div`
img{ width:100%; border: solid 1px #000;}


`;

const Logo = styled.img`
  position:relative;
  ${vw('top', -50, 0, 0)}
  ${vw('left', 0, 0, 0)}
  ${vw('width', 80, 126)}
  ${vw('height', 140, 221)}
  @media ${media.desktop} {
    position:fixed;
    left:unset;
    ${vw('right', 25, 0, 100)}
  }
`

const Title = styled.div`
 /* background-image: url(${require('src/assets/images/hero-extened.jpg')});
 background-size: cover;
  
  width:100vw;
  height:100vh; */
  ${vw('padding-top', 11, 200)}

  
  `


export default DR;
